import React from "react";
import PlayButton from "../assets/svg/play-button.svg";
import { Link } from "react-router-dom";
import Fancybox from "./Fancybox";

const Videos: React.FC = () => {
  return (
    <div className="videos">
      <div className="container">
        <div className="row">
          <div className="col-sm-6 text">
            <h5>Video</h5>
            <p>
              Dedicated to helping kids develop life-long interest in science &
              building countless competencies.
            </p>
            <Link to="/gallery">View More Videos</Link>
          </div>
          <div className="col-sm-6 video">
            <div className="image">
              <Fancybox>
                <a
                  data-fancybox
                  href="https://www.youtube.com/embed/h0l7QR-AVPI?list=PLSvl6y86TARC9_dtqPzlpfn35J2e2IgQx"
                >
                  <img src={PlayButton} alt="" srcSet="" />
                </a>
              </Fancybox>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Videos;
